import './educacao.css';
import Sidebar from '../../components/Sidebar';
import Header from '../../components/header';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChalkboardTeacher,
  faGraduationCap,
  faBookOpen,
  faUsers,
  faBook
} from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import Titulo from '../../components/Titulo/titulo';

const PainelEducacao = () => {





  return (
    <div>
      <Sidebar />
      <Header />
      <div className='container'>
        <Titulo
          children={<h2>Cadastros</h2>}
        />

        <div className='content conatiner-painel-educacao'>
          <div className='cadastros-educacao'>
            <Link to='/professores' >
              <FontAwesomeIcon icon={faChalkboardTeacher} className='icon' />
              <b>Professores</b>
            </Link>
            <Link to='/cursos'>
              <FontAwesomeIcon icon={faGraduationCap} className='icon' />
              <b>Cursos</b>
            </Link>
            <Link to='/turmas' className='confirmacao'>
              <FontAwesomeIcon icon={faUsers} className='icon' />
              <b>Turmas</b>
            </Link>
            <Link to='/disciplinas' className='confirmacao'>
              <FontAwesomeIcon icon={faBookOpen} className='icon' />
              <b>Disciplinas</b>
            </Link>
            <Link to='/acervo-educacao' className='confirmacao'>
              <FontAwesomeIcon icon={faBook} className='icon' />
              <b>Acervo</b>
            </Link>
          </div>
        </div>

      </div>
    </div >
  )
}

export default PainelEducacao
